import { render, staticRenderFns } from "./LmSuperPowerSelectV2BuilderUi.vue?vue&type=template&id=2cbd5678&"
import script from "./LmSuperPowerSelectV2BuilderUi.vue?vue&type=script&lang=js&"
export * from "./LmSuperPowerSelectV2BuilderUi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports